import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { StatementInvoiceService } from "../../app/xu-ly-sai-sot/StatementInvoiceService";
import { ToastService } from "../../AppToast";

export default function ConfirmSignStatement() {
  const [searchParams] = useSearchParams();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState({
    taxCode: "",
    opt: "",
    documentNo: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((val) => ({
      ...val,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    if (!form.taxCode) newErrors.taxCode = "Mã số thuế là bắt buộc";
    if (!form.opt) newErrors.opt = "Opt là bắt buộc";
    if (!form.documentNo) newErrors.documentNo = "Số hồ sơ là bắt buộc";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (event) => {
    setIsSubmitting(true);
    event.preventDefault();
    if (!validate()) return;
    console.log(form);
    StatementInvoiceService.confirmSign(form)
      .then(
        () => {
          ToastService.success();
        },
        () => {
          ToastService.error();
        }
      )
      .catch((error) => {
        ToastService.error(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    setForm({
      taxCode: searchParams.get("taxCode"),
      opt: searchParams.get("opt"),
      documentNo: searchParams.get("documentNo"),
    });
  }, [searchParams]);

  return (
    <div
      className="layout-wrapper layout-overlay layout-theme-light"
      style={{ backgroundColor: "#fff", height: "100vh" }}
    >
      <div className="layout-main p-3 h-full">
        <div className="grid h-full">
          <div
            className="sm:hidden md:block lg:block xl:block w-full h-full"
            style={{
              backgroundImage: "url(/assets/layout/images/bg-4.png)",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="p-5">
              <div className="mt-2">
                <img
                  src={"/assets/layout/images/logo-letter-14.png"}
                  alt="logo"
                />
              </div>
            </div>
            <div className="flex justify-content-center align-content-center flex-wrap">
              <div className="card surface-ground" style={{ width: "486px" }}>
                <div className="text-center">
                  <img
                    src={"/assets/layout/images/logo-minvoice.png"}
                    alt="logo"
                  />
                </div>

                <form
                  className="mt-3 mb-3 pb-2 pl-3 text-2xl"
                  onSubmit={handleSubmit}
                >
                  <h5 className="text-center mb-4 text-4xl">Xác nhận ký biên bản</h5>
                  <div className="flex flex-column gap-2 mb-3">
                    <label htmlFor="taxCode">
                      Mã số thuế
                      <span className="required">*</span>
                    </label>
                    <InputText
                      id="taxCode"
                      name="taxCode"
                      className="p-inputtext-lg"
                      value={form.taxCode}
                      onChange={handleChange}
                    />
                    {errors.taxCode && (
                      <small className="p-error">{errors.taxCode}</small>
                    )}
                  </div>
                  <div className="flex flex-column gap-2 mb-3">
                    <label htmlFor="opt">
                      Mã xác thực OTP Email <span className="required">*</span>
                    </label>
                    <InputText
                      id="opt"
                      name="opt"
                      className="p-inputtext-lg"
                      value={form.opt}
                      onChange={handleChange}
                    />
                    {errors.opt && (
                      <small className="p-error">{errors.opt}</small>
                    )}
                  </div>
                  <div className="flex flex-column gap-2 mb-3">
                    <label htmlFor="documentNo">
                      Số hồ sơ
                      <span className="required">*</span>
                    </label>
                    <InputText
                      id="documentNo"
                      name="documentNo"
                      className="p-inputtext-lg"
                      value={form.documentNo}
                      onChange={handleChange}
                    />
                    {errors.documentNo && (
                      <small className="p-error">{errors.documentNo}</small>
                    )}
                  </div>
                  <Button
                    className="w-full text-2xl"
                    label="Xác nhận"
                    loading={isSubmitting}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
